/* eslint-disable */
import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import {
  HourlyWages,
  costAgreement,
  costPerDay,
  costPerMonth,
  costPerWeek,
  englishTranslations,
  otherCost,
} from '../../../utils/stringUtils';
import { getVatToShow } from 'src/utils/commonFunc';
import {convertToDecimalHours, convertFromDecimalHours} from '../../../../src/utils/convertToDecimalHours'
import { InvoiceToolVersion } from 'src/utils/constants';

const WorkingHoursRow = ({
  index,
  rootDeduction,
  rutDeduction,
  dayArticle,
  dates,
  indexValue,
  setDates,
  setRemoveClickedDate,
  dateStr,
  article,
  setArticle,
  handleChangeInvoiceArticle,
  showTooltipError,
  selectedIndex,
  articles,
  control,
  isFixed,
  setShowTooltipError,
  register,
  currency,
  total,
  handleChangeAmount,
  watch,
  setSelectedIndex,
  setUnitDateStr,
  handleChangeUnit,
  setOtherArticlesData,
  setValue,
  showDates,
  vat,
  selectedCustomer,
  isBooked = false,
  prefillingData,
}) => {

  const { t } = useTranslation();
  const customerVatType = selectedCustomer?.customerAddress?.[0]?.vatType;
  const vatToShow = getVatToShow(customerVatType,vat)
  

  const translatedArticles = articles.map((article) => ({
    ...article,
    description: englishTranslations[article.description] || article.description, 
  }));
  

  return (
    <div>
      <div
        key={index}
        className={`row mobile-scroll ${
          !(rootDeduction || rutDeduction) || dayArticle?.articleNumber !== otherCost
            ? 'No-root-selected'
            : 'Root-selected'
        } flex-row mx-0 ${index === dates[indexValue]?.length - 1 ? 'mb-3 mx-0' : ''}`}
      >
        <div className="desktop-row d-initial align-items-center justify-content-start desktop-1">
          <div className="d-flex justify-content-start align-items-center">
            <AiOutlineClose
              size={24}
              className={`text-primary-custom cursor-pointer close-invoice ${isBooked ? 'disabled' : ''}`}
              onClick={() => {
                if (isBooked) return;
                Object.keys(dates).forEach((item, dateIndex) => {
                  if (dateIndex === indexValue) {
                    setDates((prevState) => {
                      return {
                        ...prevState,
                        [item]: dates[item]?.filter((_, idx) => idx !== index),
                      };
                    });
                  }
                });
                if (index === 0) {
                  setOtherArticlesData((prevData) => {
                    return {
                      ...prevData,
                      [indexValue]: [],
                    };
                  });
                }
                setRemoveClickedDate({ indexValue, dateStr });
                setValue(`defaultHours[${indexValue}.hoursPerDay]`);
                setValue(`defaultAmount[${indexValue}.amountValue]`);
              }}
              style={{
                opacity: isBooked ? 0.5 : 1,
                cursor: isBooked ? 'not-allowed' : 'pointer'
              }}
            />
            <h6 className="m-0 ml-2" style={{ color: showDates !== 'true' && '#b0b0b0' }}>
              {(() => {
                const [year, month, day] = dateStr?.split('-');
                return `${year}-${month}-${day} `;
              })()}
            </h6>
          </div>
        </div>

        <div className="desktop-row d-flex justify-content-between align-items-start desktop-2">
          <div className="col-12 d-flex justify-content-between align-items-center">

            {prefillingData?.getInvoiceData?.fetchInvoices?.invoiceToolVersion === InvoiceToolVersion.V2 &&
              !((dayArticle?.articleNumber === '92') && (prefillingData?.getInvoiceData?.fetchInvoices?.rootDeduction === true || prefillingData?.getInvoiceData?.fetchInvoices?.rutDeduction === true)) && (
                <Controller
                  name={`invoiceHours[${indexValue}][${dateStr}].customWorkingDescription`}
                  control={control}
                  rules={{
                    required: !isBooked && t("Custom description is required"),
                    maxLength: {
                      value: 42,
                      message: t("Custom description cannot exceed 42 characters"),
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <div className="mr-2" style={{ minWidth: "150px", maxWidth: "200px" }}>
                      <input
                        {...field}
                        className="form-control"
                        type="text"
                        placeholder={t("Custom Description")}
                        disabled={isBooked}
                        maxLength={42}
                      />
                      {fieldState?.error && (
                        <small className="text-danger">
                          {fieldState.error.message}
                        </small>
                      )}
                    </div>
                  )}
                />
              )}
            <Controller
              className="w-100"
              control={control}
              defaultValue={Object.keys(article).length ? article : translatedArticles[0]}
              name={`invoiceHours[${indexValue}.[${dateStr}].article]`}
              render={({ field, fieldState }) => (
                <Select
                  {...field}
                  id="articleSelect"
                  isDisabled={isFixed || isBooked}
                  className="ml-0 w-100"
                  labelKey="description"
                  selected={field.value}
                  // defaultValue={articles[0]}
                  placeholder={t("Select unit")}
                  menuPortalTarget={document.querySelector("body")}
                  getOptionLabel={(option) => {
                    const translatedLabel = englishTranslations[option?.description];
                    return translatedLabel || option?.description || '';
                  }}
                  onChange={(e) => {
                    if (isBooked) return;
                    handleChangeInvoiceArticle(e, dateStr, indexValue);
                  }}
                  noOptionsMessage={({ inputValue }) => (!inputValue ? t('No options') : t('No results found'))}
                  options={translatedArticles?.map((description) => ({
                    ...description,
                    value: description.description,
                  }))}
                  isOptionSelected={(option, selectValue) =>
                    selectValue.some(
                      (val) => val.articleNumber === option.articleNumber
                    )
                  }
                  defaultMenuIsOpen={!isFixed && !isBooked && index === 0 && total === 0}
                />
              )}
              rules={{ required: t('Select an article') }}
            />

            {dayArticle?.articleNumber === HourlyWages && (
              <>
                {rootDeduction && JSON.parse(rootDeduction) && (
                  <Controller
                    name={`invoiceHours[${indexValue}.[${dateStr}].houseworkType]`}
                    control={control}
                    render={({ field, fieldState }) => (
                      <Select
                        {...field}
                        className="ml-2"
                        selected={field.value}
                        isDisabled={isFixed || isBooked}
                        getOptionLabel={(option) => option?.name}
                        menuPortalTarget={document.querySelector('body')}
                        id="houseworkTypeSelect"
                        placeholder="Select work type"
                        labelKey="name"
                        style={{ width: '100%' }}
                        positionFixed
                        options={[
                          {
                            value: 'CONSTRUCTION',
                            name: 'Build',
                          },
                          {
                            value: 'ELECTRICITY',
                            name: 'Electricity',
                          },
                          {
                            value: 'GLASSMETALWORK',
                            name: 'Glass/sheet metal work',
                          },
                          {
                            value: 'GROUNDDRAINAGEWORK',
                            name: 'Soil/drainage work',
                          },
                          {
                            value: 'MASONRY',
                            name: 'Masonry',
                          },
                          {
                            value: 'PAINTINGWALLPAPERING',
                            name: 'Painting/wallpapering',
                          },
                          {
                            value: 'HVAC',
                            name: 'Plumbing',
                          },
                          {
                            value: 'OTHERCOSTS',
                            name: 'Other costs',
                          },
                        ]}
                      />
                    )}
                    rules={{ required: !isFixed }}
                  />
                )}
                {rutDeduction && JSON.parse(rutDeduction) && (
                  <Controller
                    name={`invoiceHours[${indexValue}.[${dateStr}].houseworkType]`}
                    control={control}
                    render={({ field, fieldState }) => (
                      <Select
                        {...field}
                        className="ml-2"
                        selected={field.value}
                        isDisabled={isFixed}
                        getOptionLabel={(option) => option?.name}
                        menuPortalTarget={document.querySelector('body')}
                        id="houseworkTypeSelect"
                        placeholder="Select work type"
                        labelKey="name"
                        style={{ width: '50%' }}
                        positionFixed
                        options={[
                          {
                            value: 'CLEANING',
                            name: 'Cleaning',
                          },
                          {
                            value: 'TEXTILECLOTHING',
                            name: 'Clothing and textile care',
                          },
                          {
                            value: 'SNOWPLOWING',
                            name: 'Snow shoveling',
                          },
                          {
                            value: 'GARDENING',
                            name: 'Gardening',
                          },
                          {
                            value: 'BABYSITTING',
                            name: 'Child care',
                          },
                          {
                            value: 'OTHERCARE',
                            name: 'Personal care',
                          },
                          {
                            value: 'MOVINGSERVICES',
                            name: 'Removal services',
                          },
                          {
                            value: 'ITSERVICES',
                            name: 'IT services',
                          },
                          {
                            value: 'MAJORAPPLIANCEREPAIR',
                            name: 'Repair of white goods',
                          },
                          {
                            value: 'FURNISHING',
                            name: 'Furnishings',
                          },
                          {
                            value: 'HOMEMAINTENANCE',
                            name: 'Supervision of housing',
                          },
                          {
                            value: 'TRANSPORTATIONSERVICES',
                            name: 'Transport services',
                          },
                          {
                            value: 'WASHINGANDCAREOFCLOTHING',
                            name: 'Washing and care of clothes',
                          },
                          {
                            value: 'OTHERCOSTS',
                            name: 'Other costs',
                          },
                        ]}
                      />
                    )}
                    rules={{ required: !isFixed }}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div className="desktop-row d-flex align-items-center justify-content-start desktop-3">
          <div className="col-md-9 col-sm-12 ghd row mx-0 p-0">
            {!(
            
              dayArticle?.articleNumber === costPerDay ||
              dayArticle?.articleNumber === costPerMonth ||
              dayArticle?.articleNumber === costPerWeek ||
              dayArticle?.articleNumber === costAgreement
            ) && (
              <div className="col-6  pl-0 pr-1 pr-1 d-flex align-items-center mobile-inline">
                                <OverlayTrigger
                  show={
                    showTooltipError.inputZeroValue ||
                    showTooltipError.inputGreater24Value ||
                    showTooltipError.nullUnit ||
                    showTooltipError.invalidUnit ||
                    showTooltipError.negativeHours ||
                    showTooltipError.inputNegatieveValue ||
                    showTooltipError.travelAllowanceGraterValue ||
                    showTooltipError.travelAllowanceLessValue
                  }
                  placement="top"
                  overlay={
                    <Popover
                      id={`popover-positioned-top`}
                      style={{ margin: 0 }}
                    >
                      <Popover.Header className="text-danger" as="h3">
                        {selectedIndex === index &&
                          showTooltipError.nullUnit &&
                          t("Please enter a unit value")}
                        {selectedIndex === index &&
                          showTooltipError.invalidUnit &&
                          t("Hours Wages value can't be grater then 13")}
                        {selectedIndex === index &&
                          showTooltipError.negativeHours &&
                          t("Hours Value Can't Be Negative")}
                        {selectedIndex === index &&
                          showTooltipError.inputNegatieveValue &&
                          t("Value cannot be Negative")}
                        {selectedIndex === index &&
                          showTooltipError.inputZeroValue &&
                          t("Value cannot be Zero")}
                        {selectedIndex === index &&
                          showTooltipError.inputGreater24Value &&
                          t("Value cannot be Greater than 24")}
                        {selectedIndex === index &&
                          showTooltipError.travelAllowanceGraterValue &&
                          t("Travel Allowance value cannot be grater then 220")}
                        {selectedIndex === index &&
                          showTooltipError.travelAllowanceLessValue &&
                          t("Travel Allowance value cannot be less then 120")}
                      </Popover.Header>
                    </Popover>
                  }
                >
                  <input
                    className="form-control w-100 no-arrows"
                    type="number"
                    step="0.001"
                    min={0}
                    max={dayArticle?.articleNumber === otherCost ? 13 : 24}
                    placeholder="Hr"
                    disabled={isFixed || isBooked}
                    onClick={() => {
                      if (isBooked) return;
                      setSelectedIndex(index);
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    onInput={(object) => {
                      if (isBooked) return;
                      setSelectedIndex(index);
                      if (
                        dayArticle?.articleNumber === otherCost &&
                        object.target.value < 0
                      ) {
                        object.target.value = "";
                        setShowTooltipError({
                          negativeHours: true,
                        });
                        setTimeout(() => {
                          setShowTooltipError({
                            negativeHours: false,
                          });
                        }, 3000);
                      }
                      //  else if (object.target.value > 13 && dayArticle?.articleNumber === HourlyWages) {
                      //   object.target.value = 13;
                      //   setShowTooltipError({ invalidUnit: true })
                      //   setTimeout(() => {
                      //     setShowTooltipError({
                      //       invalidUnit: false
                      //     })
                      //   }, 3000);
                      // }
                      else if (object.target.value < 0) {
                        object.target.value = "";
                        setShowTooltipError({
                          inputNegatieveValue: true,
                        });
                        setTimeout(() => {
                          setShowTooltipError({
                            inputNegatieveValue: false,
                          });
                        }, 3000);
                      } else if (object.target.value === "0") {
                        object.target.value = "";
                        setShowTooltipError({
                          inputZeroValue: true,
                        });
                        setTimeout(() => {
                          setShowTooltipError({
                            inputZeroValue: false,
                          });
                        }, 3000);
                      } else if (parseFloat(object.target.value) > 24) {
                        object.target.value = "";
                        setShowTooltipError({
                          inputGreater24Value: true,
                        });
                        setTimeout(() => {
                          setShowTooltipError({
                            inputGreater24Value: false,
                          });
                        }, 3000);
                      } else {
                        const value = parseFloat(object.target.value);
                        if (value < 1 || value > 24) {
                          object.target.value = "";
                        } else {
                          const decimalPlaces = (
                            value.toString()?.split(".")[1] || ""
                          ).length;
                          if (decimalPlaces > 2) {
                            object.target.value = value?.toFixed(2);
                          }
                        }
                      }
                      let value = object.target.value;
                      value = value.replace(/[^\d]/g, '');
                      if (value === '') value = '0';
                      let minutes = 0;
                      const hoursVal = watch(`invoiceHours[${indexValue}.[${dateStr}].units]`);
                      if (hoursVal && hoursVal.toString().includes('.')) {
                        const [, m] = hoursVal.toString().split('.');
                        minutes = m ? parseInt(m.slice(0, 2), 10) : 0;
                      }
                      // Always update units in H.MM format
                      const formatted = minutes === 0 ? `${parseInt(value, 10)}` : `${parseInt(value, 10)}.${minutes.toString().padStart(2, '0')}`;
                      setValue(`invoiceHours[${indexValue}.[${dateStr}].units]`, formatted, { shouldValidate: true, shouldDirty: true });
                      setValue(`defaultHours[${indexValue}.hoursPerDay]`, formatted, { shouldValidate: true, shouldDirty: true });
                    }}
                    value={(() => {
                      // Always show only the integer part in hours input
                      const hoursVal = watch(`invoiceHours[${indexValue}.[${dateStr}].units]`);
                      if (hoursVal && hoursVal.toString().includes('.')) {
                        const [h] = hoursVal.toString().split('.');
                        return h;
                      }
                      return hoursVal || '';
                    })()}
                    {...register(
                      `invoiceHours[${indexValue}.[${dateStr}].units]`,
                      {
                        required: !isFixed,
                        value:
                          watch(`defaultHours[${indexValue}.hoursPerDay]`) || 8,
                        onChange: (e) => {
                          handleChangeUnit();
                          setUnitDateStr({
                            value: e.target.value,
                            dateStr: dateStr,
                            indexValue: indexValue,
                          });
                          setArticle(dayArticle);
                          if (dayArticle?.articleNumber === "92") {
                            setValue(
                              `defaultHours[${indexValue}.hoursPerDay]`,
                              e.target.value
                            );
                          } else {
                            setValue(
                              `defaultHours[${indexValue}.hoursPerDay]`,
                              1
                            );
                          }
                        },
                      }
                    )}
                  />
                </OverlayTrigger>
                {dayArticle && (
                  <p className="m-0 ml-1">
                    {dayArticle?.articleNumber === "94"
                      ? "day"
                      : dayArticle?.articleNumber === otherCost
                      ? t("q")
                      : englishTranslations[`${dayArticle?.unit}`] || dayArticle?.unit}
                  </p>
                )}
                <OverlayTrigger
                  show={
                    showTooltipError.inputZeroMinute ||
                    showTooltipError.inputGreater59Minute ||
                    showTooltipError.inputNegativeMinute
                  }
                  placement="top"
                  overlay={
                    <Popover id={`popover-positioned-top`} style={{ margin: 0 }}>
                      <Popover.Header className="text-danger" as="h3">
                        {selectedIndex === index &&
                          showTooltipError.inputNegativeMinute &&
                          t("Minute value cannot be Negative")}
                        {selectedIndex === index &&
                          showTooltipError.inputZeroMinute &&
                          t("Minute value cannot be Zero")}
                        {selectedIndex === index &&
                          showTooltipError.inputGreater59Minute &&
                          t("Minute value cannot be Greater than 59")}
                      </Popover.Header>
                    </Popover>
                  }
                >
                  <input
                    style={{ background: (isFixed || isBooked) && "#F2F2F2" }}
                    className="form-control w-100 no-arrows ml-2"
                    type="number"
                    step="0.01"
                    max={59}
                    placeholder="00"
                    disabled={isFixed || isBooked}
                    onClick={() => {
                      if (isBooked) return;
                      setSelectedIndex(index);
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    onInput={(object) => {
                      if (isBooked) return;
                      setSelectedIndex(index);

                      let value = object.target.value;
                      // Only allow integer and max 2 digits
                      value = value.replace(/[^\d]/g, '').slice(0, 2);
                      if (value === '') value = '0';
                      let minutes = parseInt(value, 10);
                      if (isNaN(minutes)) minutes = 0;
                      if (minutes < 0) {
                        object.target.value = '';
                        setShowTooltipError({ inputNegativeMinute: true });
                        setTimeout(() => setShowTooltipError({ inputNegativeMinute: false }), 3000);
                        return;
                      }
                      if (minutes === 0) {
                        object.target.value = '';
                        setShowTooltipError({ inputZeroMinute: true });
                        setTimeout(() => setShowTooltipError({ inputZeroMinute: false }), 3000);
                        return;
                      }
                      if (minutes > 59) {
                        object.target.value = '';
                        setShowTooltipError({ inputGreater59Minute: true });
                        setTimeout(() => setShowTooltipError({ inputGreater59Minute: false }), 3000);
                        return;
                      }
                      object.target.value = value;
                      let hours;
                      const hoursVal = watch(`invoiceHours[${indexValue}.[${dateStr}].units]`);
                      if (hoursVal && hoursVal.toString().includes('.')) {
                        const [h] = hoursVal.toString().split('.');
                        hours = parseInt(h, 10);
                      } else if (hoursVal) {
                        hours = parseInt(hoursVal, 10);
                      } else {
                        hours = 0;
                      }
                      const formatted = minutes === 0 ? `${hours}` : `${hours}.${minutes.toString().padStart(2, '0')}`;
                      setValue(`invoiceHours[${indexValue}.[${dateStr}].units]`, formatted, { shouldValidate: true, shouldDirty: true });
                      setValue(`defaultHours[${indexValue}.hoursPerDay]`, formatted, { shouldValidate: true, shouldDirty: true });
                    }}
                    value={(() => {
                      // Always show only the minutes part in minutes input
                      const hoursVal = watch(`invoiceHours[${indexValue}.[${dateStr}].units]`);
                      if (hoursVal) {
                        const { minutes: minutesFromDecimal } = convertFromDecimalHours(Number(hoursVal));
                        return minutesFromDecimal || '';
                      }
                      return '';
                    })()}
                    {...register(
                      `invoiceHours[${indexValue}.[${dateStr}].minutes]`,
                      {
                        // required: !isFixed,
                        value: (() => {
                          const hoursVal = watch(`invoiceHours[${indexValue}.[${dateStr}].units]`);
                          if (hoursVal && hoursVal.toString().includes('.')) {
                            const [, m] = hoursVal.toString().split('.');
                            return m ? parseInt(m.slice(0, 2), 10) : 0;
                          }
                          return;
                        })(),
                        onChange: (e) => {
                          const minutes = e.target.value ? parseInt(e.target.value, 10) : '';
                          let hours = watch(`invoiceHours[${indexValue}.[${dateStr}].units]`);
                          hours = hours ? parseInt(hours.toString().split('.')[0], 10) : 0;
                          const decimalHours = convertToDecimalHours(Number(hours), Number(minutes));
                          const formatted = minutes === 0 ? `${hours}` : `${hours}.${minutes.toString().padStart(2, '0')}`;
                          setValue(`invoiceHours[${indexValue}.[${dateStr}].units]`, decimalHours  , { shouldValidate: true, shouldDirty: true });
                          setValue(`defaultHours[${indexValue}.hoursPerDay]`, decimalHours, { shouldValidate: true, shouldDirty: true });
                          handleChangeUnit();
                        },
                      }
                    )}
                  />
                </OverlayTrigger>
                    <p className="m-0  text-sm"> Min
                </p>
              </div>
            )}
            <div className="col pl-0 pr-1 d-flex align-items-center mobile-inline working-hours-wrap">
              <OverlayTrigger
                show={showTooltipError.LessAmount || showTooltipError.NullAmount || showTooltipError.negativeAmount}
                placement="top"
                overlay={
                  <Popover id={`popover-positioned-top`} style={{ margin: 0 }}>
                    <Popover.Header className="text-danger" as="h3">
                      {selectedIndex === index &&
                        showTooltipError.negativeAmount &&
                        t("Amount value can't be Negative")}
                    </Popover.Header>
                  </Popover>
                }
              >
                <input
                  className="form-control w-100 aa no-arrows"
                  type="text"
                  step="0.1"
                  onFocus={(e) =>
                    e.target.addEventListener(
                      'wheel',
                      (e) => {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  placeholder={currency}
                  onClick={() => {
                    if (isBooked) return;
                    setSelectedIndex(index);
                    isFixed &&
                      setShowTooltipError({
                        fixedPriceUnselect: true,
                      });
                    setTimeout(() => {
                      setShowTooltipError({
                        fixedPriceUnselect: false,
                      });
                    }, 3000);
                  }}
                  readOnly={isFixed || isBooked}
                  min="0"
                  onInput={(object) => {
                    if (isBooked) return;
                    const regex = /^\d*\.?\d*$/;
                    let inputValue = object.target.value;

                    if (!regex.test(inputValue)) {
                      // If not, remove invalid characters
                      inputValue = inputValue.replace(/[^\d.]/g, '');
                      object.target.value = inputValue;
                      const maxLength = 16;

                      if (inputValue.length > maxLength) {
                        object.target.value = inputValue.slice(0, maxLength);
                      }
                    }

                    setSelectedIndex(index);
                    if (object.target.value < 0) {
                      object.target.value = "";
                      setSelectedIndex(index);
                      setShowTooltipError({
                        negativeAmount: true,
                      });
                      setTimeout(() => {
                        setShowTooltipError({
                          negativeAmount: false,
                        });
                      }, 3000);
                    } else if (object.target.value === 0) {
                      object.target.value = "";
                    } else {
                      const inputValue = object.target.value;
                      const maxLength = 16;

                      if (inputValue.length > maxLength) {
                        object.target.value = inputValue.slice(0, maxLength);
                      }

                      if (parseFloat(inputValue) <= 0) {
                        object.target.value = "";
                      }
                    }
                  }}
                  {...register(
                    `invoiceHours[${indexValue}.[${dateStr}].amount]`,
                    {
                      // required: !isFixed,
                      value:
                        watch(`defaultAmount[${indexValue}.amountValue]`) ||
                        500,
                      onChange: (e) => {
                        handleChangeAmount();
                        setArticle(dayArticle);
                        if (dayArticle?.articleNumber !== "92") {
                          setValue(
                            `defaultHours[${indexValue}.hoursPerDay]`,
                            1
                          );
                        }
                        setValue(
                          `defaultAmount[${indexValue}.amountValue]`,
                          e.target.value
                        );
                      },
                    }
                  )}
                />
              </OverlayTrigger>
          
              <p className="m-0 ml-1">
                {currency}{" "}
                {dayArticle?.articleNumber === otherCost 
                  ? ""
                  : "/"}
                {dayArticle && dayArticle?.articleNumber === costPerDay
                  ? t("day")
                  : dayArticle?.articleNumber === otherCost
                  ? t("")
                  : englishTranslations[`${dayArticle?.unit}`] || dayArticle?.unit }
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <p className="col-4 m-0 text-right curency nw_rpns mobile-inline px-0">
              {isFixed ? t("Fixed Price") : Number(total)?.toFixed(2)}
              {" "}
              {isFixed ? "" : currency}
              <span className="ml-1 small">{`(${vatToShow}%) ${t("VAT")}`}</span>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkingHoursRow;
